import React, { useState, useEffect, Component } from "react";
import styled from "styled-components";

const UpArrow = require("../../../../assets/imgs/upArrow.png");
const DownArrow = require("../../../../assets/imgs/downArrow.png");

let sendData = [];

const PreClosure = (props) => {
  const buttonStyleEnabled = { background: "#003E8D", pointerEvents: "auto" };
  const buttonStyleDisabled = { background: "#a8aad3", pointerEvents: "none" };

  const [buttonStyle, setButtonStyle] = useState(buttonStyleEnabled);

  const { SnpComputeEMI } = props;

  useEffect(() => {

    if (props.logoutUser == false || props.logoutUser == undefined) {
      disableButtons(true);
    } else {
      disableButtons(false);
    }
  }, [props.logoutUser]);

  const disableButtons = (isDisabled) => {
    if (isDisabled) {
      setButtonStyle(buttonStyleDisabled);
    } else {
      setButtonStyle(buttonStyleEnabled);
    }
  };

  const handleProceed = () => {
    if (sendData.length == SnpComputeEMI.length) {
      let plan_index = [];
      plan_index.push(sendData[0] && sendData[0].PLAN_DATA && sendData[0].PLAN_DATA || [])
      document.getElementById("computeEMIoptions").style.pointerEvents = "none";
      let inputString = "Proceed" + "<split>" + JSON.stringify(plan_index);
      window["autosubmit"](inputString);
      setButtonStyle(buttonStyleDisabled);
      sendData = [];
    } else if (SnpComputeEMI.length == 1) {
      props.overlayMessageToggle("Please select tenure");
    } else {
      props.overlayMessageToggle(
        "Please select tenure for the other transaction"
      );
    }

  };

  //css
  const ButtonProceed = styled.div`
    width: 100%;
    margin-top: 10px;
    border-radius: 4px;
    color: #fff;
    text-align: center;
    line-height: 36px;
    cursor: pointer;
    display: inline-block;
    pointer-events: ${buttonStyle.pointerEvents};
    background: ${buttonStyle.background};
  `;
  //
  const showComputeEMI = (val) => {
    return (
      <div id="computeEMIoptions">
        {SnpComputeEMI.map((item, i) => {
          return (
            <React.Fragment key={i}>
              <EMIAccordion
                preclosurePlans={item.snpPreclosure}
                EMITenurePlans={item.snpPreclosure}
                showEMIdetail={buttonStyle==buttonStyleEnabled?i==0?true:false:false}
              />
            </React.Fragment>
          );
        })}
      </div>
    );
  };
  return (
    <React.Fragment>
      {showComputeEMI()}
      <ButtonProceed id="ConvertToEMI" onClick={() => handleProceed()}>
        Proceed
      </ButtonProceed>
    </React.Fragment>
  );
};

class EMIAccordion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      backgroundImage: this.props.showEMIdetail?UpArrow:DownArrow,
      isClicked: this.props.showEMIdetail?true:false,
      showEMIdetail: false,

    };
    this.userSelected = {
      PLAN_DATA: {},
      transactionNo: 0,
    };

    this.showEMIdetail2 = this.props.showEMIdetail;

  }

  componentWillReceiveProps() {
    this.showEMIdetail2 = this.props.showEMIdetail;
  }

  handleRadioChange = (
    selectedEMIPlan,
    transactionNum
  ) => {
 
    this.userSelected.transactionNo = transactionNum;
    this.userSelected.PLAN_DATA = selectedEMIPlan;

    if (sendData.length != 0) {
      if (
        sendData.filter((data) => data.transactionNo === transactionNum)
          .length == 0
      ) {
        sendData.push(this.userSelected);
      }
    } else {
      sendData.push(this.userSelected);
      
    }
    
  };

  render() {
    const ComputeEMI_mainBlock = styled.div`
      position: relative;
      display: flex;
      flex-direction: column;
      margin: 12px 4px 0px 4px;
      border: 1px solid #fcfcfc;
      border-radius: 4px;
      box-shadow: 0px 5px 12px rgba(0, 0, 0, 0.2);
      background: #fcfcfc;
    `;
    const EMI_detailBlock = styled.div`
      & .computeEMI_amount {
        padding: 0 16px 16px 16px;
        font-size: 14px;
      }

      & .EMI_tenure {
        display: flex;
        flex-direction: column;
      }

      & .sf-radioSelect {
        font-size: 14px;
        padding: 10px;
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: 6px;
        margin: 8px 8px 8px 8px;
        display: flex;
        color: #003e8d;
        font-weight: 500;
        flex-direction: column;
        align-items: flex-start;
        justofy-content: space-betwwen
        gap: 12px;

        :last-child {
            margin: 0px 8px 8px 8px;
        }

        .radio-title-box {
            display: flex;
            flex-direction: row;
            gap: 8px;
            align-items: center;
        }
        label {
          .plan-description {
            font-size: 12px;
            font-weight: 300;
            color: #666666;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            gap: 12px;
          }
        }
     

        input[type=radio]+label {
          height: 0px;
          width: 100%;
          display: inline-block;
          margin: 0px 0px 0 0;
          position: relative;
          padding: 0;
          background: none;
          background-size: none;
          top: 0px;
          color: #003e8d;

        }

        input[type=radio] {

          display: inline-block;
          margin: 0;
        }
        
    `;
    //
    return (
      <ComputeEMI_mainBlock>
          <EMI_detailBlock>
            <div className="EMI_tenure" id="EMIplanResponse">
              {this.props.EMITenurePlans.map((item, i) => {
                return (
                  <div
                    className="sf-radioSelect"
                    key={i}
                    onChange={() =>
                      this.handleRadioChange(
                        item,
                        item.PlanNo,
                      )
                    }
                  >
                    <div className="radio-title-box">
                        <input
                        type="radio"
                        style={{ cursor: "pointer", width: "auto"}}
                        name={item.PlanDesc}
                        />
                        {/* <div
                            style={{
                            fontSize: "12px",
                            fontWeight: "300",
                            color: "#666666",
                            }}
                        >
                            {item.PlanOpenDt}
                        </div> */}
                    </div>
                    <label>
                      {item.PlanDesc}
                      { item.PlanOpenDt &&
                      <div
                        className="plan-description"
                      >
                        <p>Plan Open Date: </p><p>{item.PlanOpenDt}</p>
                      </div>}
                      {/* { item.PlanBalance &&
                      <div
                        className="plan-description"
                      >
                        <p>Plan Balance: </p><p>₹{item.PlanBalance}</p>
                      </div>} */}
                      { item.MonthlyEMI &&
                      <div
                        className="plan-description"
                      >
                        <p>Monthly EMI: </p><p>₹{item.MonthlyEMI}</p>
                      </div>}
                      { item.PrincipleBalance &&
                      <div
                        className="plan-description"
                      >
                        <p>Principle Balance: </p><p>₹{item.PrincipleBalance}</p>
                      </div>}
                      { item.TransactionAmount &&
                      <div
                        className="plan-description"
                      >
                        <p>Transaction Amount: </p><p>₹{item.TransactionAmount}</p>
                      </div>}
                      { item.Foreclosure &&
                      <div
                        className="plan-description"
                      >
                        <p>Foreclosure Amount: </p><p>₹{item.Foreclosure}</p>
                      </div>}
                    </label>
                  </div>
                );
              })}
            </div>
          </EMI_detailBlock>
      </ComputeEMI_mainBlock>
    );
  }
}
export default PreClosure;
